module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chat-room"
  }, [_c('div', {
    staticClass: "display-flex align-center justify-space-between pt-5 pb-4 px-4"
  }, [_c('div', {
    staticClass: "text-poppins-18 text-white"
  }, [_vm._v("Chat rooms")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../../assets/mobile/icon/arrow-down-white.svg"),
      "width": "27"
    },
    on: {
      "click": function($event) {
        _vm.$router.push({
          name: 'CommunityMobile'
        })
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "horizontal-scroll px-4"
  }, _vm._l((10), function(i) {
    return _c('div', {
      key: i,
      staticClass: "horizontal-scroll__item mr-2 mb-2"
    }, [_vm._m(0, true)])
  })), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "bg-white chat-room__comment relative"
  }, [_vm._m(2), _vm._v(" "), _vm._l((2), function(i) {
    return _c('div', {
      key: i,
      staticClass: "display-flex gap-15 my-3 px-4"
    }, [_c('img', {
      staticClass: "rounded",
      attrs: {
        "src": require("../../assets/mobile/notification_2.png"),
        "width": 44,
        "height": 44
      }
    }), _vm._v(" "), _vm._m(3, true)])
  }), _vm._v(" "), _c('div', {
    staticClass: "display-flex align-center gap-10 chat-room__comment--input"
  }, [_c('img', {
    staticClass: "rounded",
    attrs: {
      "src": require("../../assets/mobile/icon/cricle-add.svg"),
      "width": 35,
      "height": 35
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "input-comment full-width pa-2",
    attrs: {
      "type": "text",
      "placeholder": "Say something!"
    }
  })])], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('img', {
    attrs: {
      "src": require("../../assets/mobile/you.png"),
      "width": "50",
      "height": "50"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "px-4"
  }, [_c('iframe', {
    attrs: {
      "width": "100%",
      "height": "315",
      "src": "https://www.youtube.com/embed/2Te4Dhhy0-U?si=UlNm6BTTXkBUGi7E",
      "title": "YouTube video player",
      "frameborder": "0",
      "allow": "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share",
      "allowfullscreen": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "display-flex algin-center justify-space-between mb-2 pa-4"
  }, [_c('span', {
    staticClass: "text-poppins-16 font-weight-500 text-black"
  }, [_vm._v("\n        Salva’s room\n      ")]), _vm._v(" "), _c('span', {
    staticClass: "text-poppins-13 font-weight-500 text-black"
  }, [_vm._v("\n        36 watching\n      ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "message"
  }, [_c('div', [_c('span', {
    staticClass: "text-inter-14 text-white font-weight-500"
  }, [_vm._v("\n            Joey •\n          ")]), _vm._v(" "), _c('span', {
    staticClass: "text-inter-14 text-white"
  }, [_vm._v("1m")])]), _vm._v(" "), _c('div', {
    staticClass: "text-inter-14 text-white"
  }, [_vm._v("I’m down! Any ideas??")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5888a926","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/new-mobile/chat_room.vue
// module id = 1733
// module chunks = 180